const BASIC = '/api';
const BASIC_V1 = '/api/v1/ext';

export const GET_PRODUCT_INVENTORY_API = `${BASIC}/inventory/products`;
export const GET_PRODUCT_INVENTORY_SHARE_API = `${BASIC}/inventory/products/share`;
export const GET_PRODUCT_BY_SHARE_CODE_API = `${BASIC_V1}/inventory/products`;
export const POST_SHARE_FILTER_RESULT_API = `${BASIC}/inventory/products/share`;
